import { createContext } from 'react'

import type { TrackingContextValue } from 'containers/TrackingProvider/types'

const TrackingContext = createContext<TrackingContextValue | undefined>(undefined)

export default TrackingContext
